/*
 * Copyright (c) 2021 LucidResolutions LLC. All rights reserved.
 */

import axios from 'axios'

const pathRegex = /[/]+/g
class APIBaseService {
    baseUrl;
    pathPrefix;

    constructor() {
        this.baseUrl =  "";
    }

    usePathPrefix(prefix){
        this.pathPrefix = prefix;
        if(this.pathPrefix){
            let prefix = `/${this.pathPrefix}`
            this.baseUrl = `${this.baseUrl}${prefix.replace(pathRegex, '/')}`
        }
    }

    async request(promise, expectedStatus){
        let result = await promise
        this.raiseIfBadStatus(result, expectedStatus)

        return result
    }

    async path(path) {
        if(path){
            path = `/${path}`
        }

        let url = `${this.baseUrl}${path||''}`.replace(pathRegex, '/')

        return url
    }

    async delete(path, config) {
        return await axios.delete(await this.path(path), config)
    }

    async get(path, config) {
        return await axios.get(await this.path(path), config)
    }

    async post(path, data, config) {
        return await axios.post(await this.path(path), data, config)
    }

    async patch(path, data, config) {
        return await axios.patch(await this.path(path), data, config)
    }

    async put(path, data, config) {
        return await axios.put(await this.path(path), data, config)
    }

    raiseIfBadStatus(response, expected) {
        let status;
        let resp;
        if(response?.status){
            status = response?.status
            resp = response;
        } else if(response?.response?.status) {
            status = response?.response.status
            resp = response.response
        }

        if(status != expected){
            let err = new Error()
            err.data = resp
            err.message = `expected status code of ${expected} but got ${status}`
            err.type = "api-error"
            err.status = status
            err.rawErrorMessage = resp?.data?.error?.message || resp?.data?.error?.Message
            throw err;
        }
    }

}

export default APIBaseService;
